(function () {
  var ENDPOINT = "https://api.shilajit.work/api/meta/funnel-shadow";
  var SENT = {};
  var ANON_KEY = "_hng_meta_anon_id";
  var ANON_TS_KEY = "_hng_meta_anon_id_ts";
  var ANON_TTL_MS = 90 * 24 * 60 * 60 * 1000;
  // P1 browser<->CAPI dedup: events for which we ALSO fire a content-less Meta
  // pixel track sharing this event's event_id. Meta dedups it against the CAPI
  // event (same event_id) and merges the in-context _fbp (which the pixel sets
  // reliably) with the server identity. ONLY events the server CAPI also sends
  // are listed, so every browser track has a CAPI twin to dedup against (no
  // standalone browser volume). PageView (no CAPI counterpart) and
  // InitiateCheckout (its CAPI twin is the customer_event source with a
  // DIFFERENT event_id, so a browser IC track would not dedup and would
  // double-count) are intentionally ABSENT.
  var DEDUP_TRACK_EVENTS = { ViewContent: 1, ViewCart: 1, Search: 1 };

  function cookie(name) {
    try {
      var parts = ("; " + document.cookie).split("; " + name + "=");
      return parts.length === 2 ? decodeURIComponent(parts.pop().split(";").shift()) : "";
    } catch (e) {
      return "";
    }
  }

  function looksLikeFbc(value) {
    return /^fb\.1\.\d+\.[^\s.][^\s]*$/.test(String(value || ""));
  }

  function looksLikeFbp(value) {
    return /^fb\.1\.\d+\.\d+$/.test(String(value || ""));
  }

  function looksLikeHngAnon(value) {
    return /^hnganon_[a-f0-9]{32}$/.test(String(value || ""));
  }

  function randomHex32() {
    var bytes = [];
    try {
      if (window.crypto && window.crypto.getRandomValues) {
        var arr = new Uint8Array(16);
        window.crypto.getRandomValues(arr);
        for (var i = 0; i < arr.length; i += 1) bytes.push(arr[i]);
      }
    } catch (e) {}
    while (bytes.length < 16) bytes.push(Math.floor(Math.random() * 256));
    return bytes
      .map(function (b) {
        return ("0" + b.toString(16)).slice(-2);
      })
      .join("");
  }

  function readAttributionData() {
    try {
      var stored = window.localStorage && window.localStorage.getItem("_attribution_data");
      if (stored) return JSON.parse(stored);
    } catch (e) {}
    try {
      var raw = cookie("_attribution_data");
      if (raw) return JSON.parse(raw);
    } catch (e) {}
    return {};
  }

  function rawParam(name) {
    try {
      var search = window.location && window.location.search ? window.location.search : "";
      var re = new RegExp("(?:^|[?&])" + name + "=([^&]+)");
      var match = search.match(re);
      return match ? match[1] : "";
    } catch (e) {
      return "";
    }
  }

  function validRawFbclid(value) {
    return /^[^\s.][^\s]*$/.test(String(value || ""));
  }

  function normalizeFbc(value) {
    if (!looksLikeFbc(value)) return "";
    var clean = String(value).trim();
    var parts = clean.split(".");
    var ts = Number(parts[2]);
    if (!ts || ts < 1500000000) return "";
    if (ts < 1000000000000) {
      parts[2] = String(Math.floor(ts * 1000));
      return parts.join(".");
    }
    return clean;
  }

  function metaFbc(data, eventTime) {
    var direct = cookie("_fbc") || (data && data.fbc);
    var normalized = normalizeFbc(direct);
    if (normalized) return normalized;
    var fbclid = rawParam("fbclid") || (data && data.fbclid) || "";
    if (!validRawFbclid(fbclid)) return "";
    var ts = Number(data && data.captured_at);
    if (!ts || ts < 1500000000) return "";
    if (ts < 1000000000000) ts = ts * 1000;
    return "fb.1." + Math.floor(ts) + "." + fbclid;
  }

  function metaFbp(data) {
    var direct = cookie("_fbp") || (data && data.fbp);
    return looksLikeFbp(direct) ? String(direct).trim() : "";
  }

  function privacyAllowed() {
    try {
      var privacy = window.Shopify && window.Shopify.customerPrivacy;
      if (!privacy) return true;
      if (
        typeof privacy.analyticsProcessingAllowed === "function" &&
        typeof privacy.marketingAllowed === "function"
      ) {
        return privacy.analyticsProcessingAllowed() || privacy.marketingAllowed();
      }
    } catch (e) {}
    return true;
  }

  function metaAnonId() {
    if (!privacyAllowed()) return "";
    try {
      var now = Date.now();
      var stored = window.localStorage && window.localStorage.getItem(ANON_KEY);
      var storedAt = Number(window.localStorage && window.localStorage.getItem(ANON_TS_KEY));
      if (looksLikeHngAnon(stored) && storedAt && now - storedAt < ANON_TTL_MS) {
        return stored;
      }
      var fresh = "hnganon_" + randomHex32();
      if (!looksLikeHngAnon(fresh)) return "";
      if (window.localStorage) {
        window.localStorage.setItem(ANON_KEY, fresh);
        window.localStorage.setItem(ANON_TS_KEY, String(now));
      }
      return fresh;
    } catch (e) {
      return "";
    }
  }

  function hashish(input) {
    var raw = String(input || "");
    var h = 0;
    for (var i = 0; i < raw.length; i += 1) {
      h = (Math.imul(31, h) + raw.charCodeAt(i)) | 0;
    }
    return Math.abs(h).toString(36);
  }

  function postBeacon(body) {
    if (navigator.sendBeacon) {
      var blob = new Blob([body], { type: "text/plain;charset=UTF-8" });
      if (navigator.sendBeacon(ENDPOINT, blob)) return;
    }
    if (window.fetch) {
      fetch(ENDPOINT, {
        method: "POST",
        mode: "cors",
        credentials: "omit",
        keepalive: true,
        headers: { "Content-Type": "text/plain;charset=UTF-8" },
        body: body,
      }).catch(function () {});
    }
  }

  // The site-wide base Meta pixel loads fbevents.js asynchronously, so on a
  // fresh page load the _fbp cookie is usually not set yet when a page-load
  // event (e.g. ViewContent) fires. Send immediately (never lose the event),
  // then if fbp was missing poll briefly and re-send the SAME event_id once the
  // cookie lands. The shadow ingest merges on conflict (best-identity-wins) so
  // this only backfills fbp; the same event_id is deduped downstream so it can
  // never double-count. Consent is re-checked every tick because Shopify
  // privacy state can hydrate, or the visitor can revoke, during the wait.
  function backfillFbp(payload) {
    var tries = 0;
    var iv = setInterval(function () {
      if (!privacyAllowed()) {
        clearInterval(iv);
        return;
      }
      tries += 1;
      var fbp = metaFbp(readAttributionData());
      if (fbp) {
        clearInterval(iv);
        payload.fbp = fbp;
        try { postBeacon(JSON.stringify(payload)); } catch (e) {}
      } else if (tries >= 20) {
        clearInterval(iv);
      }
    }, 150);
  }

  function send(payload) {
    try {
      if (!privacyAllowed()) return;
      var attribution = readAttributionData();
      payload.event_time = payload.event_time || Math.floor(Date.now() / 1000);
      payload.fbp = metaFbp(attribution);
      payload.fbc = metaFbc(attribution, payload.event_time);
      var anonId = metaAnonId();
      if (anonId) payload.external_id_raw = anonId;
      payload.event_source_url =
        window.location && window.location.href
          ? window.location.href
          : "https://naturalshilajit.com/";
      payload.source = payload.source || "theme";
      if (SENT[payload.event_id]) return;
      SENT[payload.event_id] = true;
      postBeacon(JSON.stringify(payload));
      if (!payload.fbp) backfillFbp(payload);
      // P1 dedup track. CONTENT-LESS by construction ({} custom data), so the
      // Meta catalog can never be polluted by this call (the reason the browser
      // pixel was decommissioned). fbevents queues the call until it loads and
      // fires it WITH the _fbp cookie, so the browser event carries fbp ~100%;
      // Meta dedups it against the same-event_id CAPI event and merges identity.
      try {
        if (window.fbq && DEDUP_TRACK_EVENTS[payload.event_name]) {
          window.fbq("track", payload.event_name, {}, { eventID: payload.event_id });
        }
      } catch (e) {}
    } catch (e) {}
  }

  function currentVariantId() {
    try {
      var params = new URLSearchParams(window.location.search || "");
      var variant = params.get("variant");
      if (variant) return String(variant);
    } catch (e) {}
    var input = document.querySelector(
      'form[action*="/cart/add"] input[name="id"], form[action*="/cart/add"] select[name="id"]'
    );
    return input && input.value ? String(input.value) : "";
  }

  function currentPrice() {
    var input = document.querySelector('form[action*="/cart/add"] input[name="ns_meta_variant_price_cents"]');
    var cents = input && input.value ? Number(input.value) : 0;
    if (cents > 0) return Number((cents / 100).toFixed(2));
    return null;
  }

  function contentPayload() {
    var variant = currentVariantId();
    if (!variant) return null;
    var price = currentPrice();
    var payload = {
      content_ids: [variant],
      contents: [{ id: variant, quantity: 1 }],
      currency: "USD",
      variant_id: variant,
    };
    if (price && price > 0) {
      payload.value = price;
      payload.contents[0].item_price = price;
    }
    return payload;
  }

  function trackPageView() {
    send({
      event_name: "PageView",
      event_id: "ns-theme-pv-" + Date.now() + "-" + hashish(window.location.pathname),
    });
  }

  function trackViewContent() {
    if (!/\/products\//.test(window.location.pathname || "")) return;
    var content = contentPayload();
    if (!content) return;
    content.event_name = "ViewContent";
    content.event_id = "ns-theme-vc-" + Date.now() + "-" + content.variant_id;
    send(content);
  }

  function trackSearch() {
    if (!/\/search/.test(window.location.pathname || "")) return;
    send({
      event_name: "Search",
      event_id: "ns-theme-search-" + Date.now() + "-" + hashish(window.location.search),
    });
  }

  function trackViewCart() {
    if (!/\/cart\/?$/.test(window.location.pathname || "")) return;
    fetch("/cart.js", { credentials: "same-origin" })
      .then(function (resp) {
        return resp.json();
      })
      .then(function (cart) {
        var contents = [];
        var ids = [];
        var items = cart && cart.items ? cart.items : [];
        for (var i = 0; i < items.length; i += 1) {
          var item = items[i];
          var id = item && item.variant_id ? String(item.variant_id) : "";
          var price = item && item.final_price ? Number((item.final_price / 100).toFixed(2)) : 0;
          var quantity = item && item.quantity ? Number(item.quantity) : 1;
          if (!id || price <= 0 || quantity <= 0) continue;
          ids.push(id);
          contents.push({ id: id, quantity: quantity, item_price: price });
        }
        var value = cart && cart.total_price ? Number((cart.total_price / 100).toFixed(2)) : 0;
        if (!ids.length || value <= 0) return;
        send({
          event_name: "ViewCart",
          event_id: "ns-theme-viewcart-" + hashish(cart.token || Date.now()),
          content_ids: ids,
          contents: contents,
          value: value,
          currency: "USD",
        });
      })
      .catch(function () {});
  }

  function bindCheckoutClickFallback() {
    document.addEventListener(
      "click",
      function (event) {
        var target = event.target && event.target.closest
          ? event.target.closest('a[href*="/checkout"], button[name="checkout"], input[name="checkout"]')
          : null;
        if (!target) return;
        fetch("/cart.js", { credentials: "same-origin" })
          .then(function (resp) {
            return resp.json();
          })
          .then(function (cart) {
            var contents = [];
            var ids = [];
            var items = cart && cart.items ? cart.items : [];
            for (var i = 0; i < items.length; i += 1) {
              var item = items[i];
              var id = item && item.variant_id ? String(item.variant_id) : "";
              var price = item && item.final_price ? Number((item.final_price / 100).toFixed(2)) : 0;
              var quantity = item && item.quantity ? Number(item.quantity) : 1;
              if (!id || price <= 0 || quantity <= 0) continue;
              ids.push(id);
              contents.push({ id: id, quantity: quantity, item_price: price });
            }
            var value = cart && cart.total_price ? Number((cart.total_price / 100).toFixed(2)) : 0;
            if (!ids.length || value <= 0) return;
            send({
              event_name: "InitiateCheckout",
              source: "theme",
              event_id: "ns-theme-ic-" + hashish(cart.token || Date.now()),
              content_ids: ids,
              contents: contents,
              value: value,
              currency: "USD",
            });
          })
          .catch(function () {});
      },
      true
    );
  }

  trackPageView();
  trackViewContent();
  trackSearch();
  trackViewCart();
  bindCheckoutClickFallback();
})();
